import React from 'react';
import { Icon } from '@plone/volto/components';
import underlineSVG from '@plone/volto/icons/underline.svg';

// Pulsante personalizzato per l'underline
export const UnderlineButton = ({ editor, className, active, onToggle }) => {
  const isActive = active && active.underline;
  
  const handleClick = (e) => {
    e.preventDefault();
    onToggle({ format: 'underline' });
  };

  return (
    <button
      className={`slate-inline-button ${isActive ? 'active' : ''} ${className || ''}`}
      style={{ 
        border: 'none', 
        background: isActive ? '#ddd' : 'transparent', 
        borderRadius: '3px',
        cursor: 'pointer',
        padding: '4px'
      }}
      onClick={handleClick}
      onMouseDown={(e) => e.preventDefault()}
      title="Sottolineato"
    >
      <Icon name={underlineSVG} size="24px" />
    </button>
  );
};

// Funzione per renderizzare il testo sottolineato
export const renderUnderlineLeaf = ({ attributes, children, leaf }) => {
  if (leaf.underline) {
    return (
      <span style={{ textDecoration: 'underline' }} {...attributes}>
        {children}
      </span>
    );
  }
  return children;
};

// Esportazione del plugin completo
export default {
  // Funzione per renderizzare il leaf (testo con formattazione)
  renderLeaf: renderUnderlineLeaf,
  
  // Aggiungi l'hotkey mod+u per underline
  hotkey: {
    'mod+u': 'underline',
  },
  
  // Estensioni di Slate
  extensions: [
    {
      id: 'underline',
      isLeaf: true,
    },
  ],
  
  // Definizione del pulsante per la toolbar
  toolbarButtons: [
    {
      id: 'underline',
      button: UnderlineButton,
    },
  ],
  
  // Definizione del pulsante per la toolbar inline
  inlineToolbarButtons: [
    {
      id: 'underline',
      button: UnderlineButton,
    },
  ],
};